import { handleActions } from 'redux-actions';

import { deleteEntities } from 'shared/store/modules/entities';
import { fetchAllSubscribersResponse, fetchSubscriberResponse } from 'shared/store/modules/subscribers/actions';

const defaultState = [];

export default handleActions(
  {
    [fetchAllSubscribersResponse]: {
      next: (_state, { payload }) => [...payload.result]
    },

    [fetchSubscriberResponse]: {
      next: (state, { payload }) => {
        if (!state.find(id => id === payload.result)) {
          return [...state, payload.result];
        }

        return state;
      }
    },

    [deleteEntities]: {
      next: (state, { payload }) => {
        if (Array.isArray(state)) {
          return state.filter(id => id !== payload.id);
        }

        return state;
      }
    }
  },

  defaultState
);
